/*
 * @Author: zyy
 * @Date: 2023-03-28 12:13:43
 * @LastEditTime: 2025-02-21 15:23:06
 * @FilePath: /tjzhsq-admin/src/io/system_config.js
 * @Description: yahu~
 * 
 */
import Axios from 'axios';
import Qs from 'qs';

export default {

  get(
    key
  ) {
    return Axios.get('base/api/admin/set-up', {
      params: {
        key
      }
    });
  },

  set(
    key,
    value
  ) {
    return Axios.patch('base/api/admin/set-up', {
      key,
      value
    });
  }

}